"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.border = void 0;
exports.border = {
    width: {
        borderXs: '1px',
        borderSm: '2px',
        borderMd: '4px',
        borderLg: '6px',
    },
    radius: {
        borderSm: '2px',
        borderMd: '4px',
        borderLg: '6px',
        borderXl: '8px',
        border2xl: '16px',
        border3xl: '24px',
        borderCircle: '50%',
    },
    style: {
        solid: 'solid',
        none: 'none',
    },
};
//# sourceMappingURL=border.js.map